$(document).on('click', '[data-change-value]:not(.alerts__option__change--custom)', function () {
    var cell = $(this),
        chosen_change = cell.data('change-value');
    $('[data-change]').data('change', chosen_change);
    $('[data-change-value]').removeClass('alerts__option__change--chosen');
    cell.addClass('alerts__option__change--chosen');
});

$(document).on('click', '[data-percent-value]:not(.alerts__option__percentage--custom)', function () {
    var cell = $(this),
        chosen_percent = cell.data('percent-value');
    $('[data-percent]').data('percent', chosen_percent);
    $('[data-percent-value]').removeClass('alerts__option__percentage--chosen');
    cell.addClass('alerts__option__percentage--chosen');
});

$(document).on('click', '[data-metal-value]:not(.alerts__option__metal--custom)', function () {
    var cell = $(this),
        chosen_metal = cell.data('metal-value');
    $('[data-metal]').data('metal', chosen_metal);
    $('[data-metal-value]').removeClass('alerts__option__metal--chosen');
    cell.addClass('alerts__option__metal--chosen');
});

$(document).on('keyup', '.alerts__option__change--custom', function () {
    var cell = $(this),
        chosen_change = cell.html();
    $('[data-change]').data('change', chosen_change);
    $('[data-change-value]').removeClass('alerts__option__change--chosen');
    cell.addClass('alerts__option__change--chosen');
});

$(document).on('keyup', '.alerts__option__percentage--custom', function () {
    var cell = $(this),
        chosen_percent = cell.html();
    $('[data-percent]').data('percent', chosen_percent);
    $('[data-percent-value]').removeClass('alerts__option__percentage--chosen');
    cell.addClass('alerts__option__percentage--chosen');
});

$(document).on('keyup', '.alerts__option__metal--custom', function () {
    var cell = $(this),
        chosen_metal = cell.html();
    $('[data-metal]').data('metal', chosen_metal);
    $('[data-metal-value]').removeClass('alerts__option__metal--chosen');
    cell.addClass('alerts__option__metal--chosen');
});
